import {FlexLayoutConfig} from '../layouts/flex-layout/flex-layout.config';
import {FieldConfig} from '../dynamic-field/field.config';

export class DynamicFormConfig {
    fields: Array<FieldConfig<any>>;
    name?: string;
    class?: string;
    layout?: string;
    layouts?: FlexLayoutConfig[];
}
